<div class="public-container">
  <iframe src="https://player.vimeo.com/video/473078793?background=1&autoplay=1&loop=1&byline=0&title=0"
          frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
  <router-outlet></router-outlet>
</div>
